import ReceiptService from '@/api/ReceiptService'

// initial state
const state = {
  receipts: [],
  receipt: null,
  nextRtCode: null,
}

// getters
const getters = {
  getReceipts: state => state.receipts,
  getReceipt: state => state.receipt,
  getNextRtCode: state => state.nextRtCode,
  getReceiptStatus: (state) => (receipt, $t, mixin) => {
    return {
      message: $t('status.in.completed'),
      status: 'completed',
    }
  },
}

// mutations
const mutations = {
  setReceipts (state, data) {
    state.receipts = data
  },
  setReceipt (state, data) {
    state.receipt = data
  },
  setNextRtCode (state, data) {
    state.nextRtCode = data
  },
  updateReceiptStatus (state, data) {
    if (state.receipt) {
      if (state.receipt.in_id == data.in_id) {
        state.receipt.status = data.status
      }
    }
    if (state.receipts.length > 0) {
      state.receipts.map((p, idx) => {
        if (p.in_id == data.in_id) {
          return p.status = data.status
        }
      })
    }
  },
}

// actions
const actions = {
  async getReceipts ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getReceipts') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getReceipts')

      let response = await ReceiptService.getAll(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getReceipts')

      result = response.data

      if (result.success) {
        commit('setReceipts', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearReceipts ({ commit }) {
    commit('setReceipts', [])
  },
  async getReceipt ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getReceipt') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getReceipt')

      let response = await ReceiptService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getReceipt')

      result = response.data

      if (result.success) {
        if (result.data.length > 0) {
          commit('setReceipt', result.data[0])
        } else {
          // not found data
          this.dispatch('Error', 'Not found data')
        }
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearReceipt ({ commit }) {
    commit('setReceipt', null)
  },
  async insertReceipt ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await ReceiptService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getNextRtCode ({ commit }) {
    var result = null

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getNextRtCode') >= 0) return

    try {
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getNextRtCode')

      let response = await ReceiptService.getLatestCode()

      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getNextRtCode')

      result = response.data

      if (result.success) {
        commit('setNextRtCode', result.data.next)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteReceipt ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ReceiptService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateReceipt ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ReceiptService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateReceiptStatus ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ReceiptService.updateStatus(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        commit('updateReceiptStatus', data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Receipt.js